import { DEFAULT_INTL_CONFIG, IntlErrorCode, type OnErrorFn } from '@formatjs/intl';

/**
 * Feature gate controlling whether `MISSING_TRANSLATION` errors are suppressed
 * in the various Post Office intl providers.
 *
 * Switcheroo: https://switcheroo.atlassian.com/ui/gates/key/post_office_suppress_missing_translation_errors
 */
export const SUPPRESS_MISSING_TRANSLATION_ERRORS_GATE =
	'post_office_suppress_missing_translation_errors';

/**
 * react-intl `onError` handler that swallows `MISSING_TRANSLATION` errors so they
 * do not spam the local devloop console, while still delegating all other errors
 * to react-intl's default handler.
 *
 * Shared between `IntlProvider` and `i18nProvider` so both migration paths behave
 * identically.
 *
 * See: https://github.com/formatjs/formatjs/issues/465#issuecomment-643887472
 */
export const handleError: OnErrorFn = (err) => {
	if (err?.code === IntlErrorCode.MISSING_TRANSLATION) {
		return;
	}

	return DEFAULT_INTL_CONFIG.onError(err);
};
